module.exports = __webpack_public_path__ + "static/img/backCorner.0c849ade.png";